import { type InputHTMLAttributes, useRef } from "react";

type Props = Omit<InputHTMLAttributes<HTMLInputElement>, "onChange" | "onCompositionStart" | "onCompositionEnd"> & {
  onValueChange?: (value: string, input: HTMLInputElement) => void;
};

export default function ClassNameInput({ onValueChange, ...props }: Props) {
  const composing = useRef(false);
  function uppercase(input: HTMLInputElement) {
    const original = input.value;
    const start = input.selectionStart;
    const end = input.selectionEnd;
    const value = original.toLocaleUpperCase();
    if (value !== original) {
      input.value = value;
      if (start !== null && end !== null)
        input.setSelectionRange(
          original.slice(0, start).toLocaleUpperCase().length,
          original.slice(0, end).toLocaleUpperCase().length,
        );
    }
    return value;
  }
  return (
    <input
      {...props}
      autoCapitalize="characters"
      onChange={(event) => {
        const input = event.currentTarget;
        const value = composing.current ? input.value : uppercase(input);
        onValueChange?.(value, input);
      }}
      onCompositionStart={() => {
        composing.current = true;
      }}
      onCompositionEnd={(event) => {
        composing.current = false;
        const input = event.currentTarget;
        onValueChange?.(uppercase(input), input);
      }}
    />
  );
}
